import { CartScopeEq } from '@/models/cart/group/scope'
import { ContextToCreateUrl } from '@/page/url/factory/url-factory'
import { CartPageProps } from '@spa/components/pages/cart/model/cart/props'
import { CartServiceLocator, selectLocatorByScope } from '@spa/components/pages/cart/model/cart/service-locator'
import { Route } from 'vue-router'

type Builder = (route: Route) => {
  scope: CartScopeEq
  context: ContextToCreateUrl
}

export const propsForCart = (build: Builder) =>
  (route: Route): CartPageProps => {
    const { scope, context } = build(route)
    const serviceLocator: CartServiceLocator = selectLocatorByScope(scope)

    return {
      scope,
      context,
      ...serviceLocator,
    }
  }
